import "./new-space-redirect.css";

const configuredBaseUrl = import.meta.env.BASE_URL_NEW_SPACE?.trim();
const newSpaceBaseUrl = (configuredBaseUrl || "http://localhost:5173").replace(
  /\/+$/,
  "",
);

function newSpaceUrl(path: string) {
  return `${newSpaceBaseUrl}/${path.replace(/^\/+/, "")}`;
}

function ArrowIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12h14M14 7l5 5-5 5" />
    </svg>
  );
}

const tools = [
  {
    label: "Programmes et projets",
    icon: <path d="M3 7h6l2 2h10v10H3z" />,
  },
  {
    label: "Financements",
    icon: (
      <>
        <ellipse cx="12" cy="5" rx="7" ry="3" />
        <path d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
      </>
    ),
  },
  {
    label: "Indicateurs d’impact",
    icon: <path d="M4 20V11h4v9M10 20V5h4v15M16 20v-8h4v8M2 20h20" />,
  },
  {
    label: "Documents et preuves",
    icon: <path d="M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h7" />,
  },
];

export default function NewSpaceRedirectPage() {
  const loginUrl = newSpaceUrl("login");
  const contactUrl = newSpaceUrl("contact");

  return (
    <div className="new-space-page">
      <header className="new-space-topbar">
        <div className="new-space-topbar__inner">
          <div className="new-space-brands" aria-label="Verdeo rejoint CreoBoard">
            <img
              className="new-space-logo new-space-logo--verdeo"
              src="/new-space/verdeo-logo.png"
              alt="Verdeo"
            />
            <span className="new-space-brand-arrow" aria-hidden="true">
              <ArrowIcon />
            </span>
            <a href={loginUrl} aria-label="Accéder à mon nouvel espace CreoBoard">
              <img
                className="new-space-logo new-space-logo--creoboard"
                src="/new-space/creoboard-logo.png"
                alt="CreoBoard"
              />
            </a>
          </div>

          <a className="new-space-help" href={contactUrl}>
            Besoin d’aide&nbsp;?
          </a>
        </div>
      </header>

      <main className="new-space-hero">
        <div className="new-space-hero__inner">
          <section className="new-space-copy" aria-labelledby="new-space-title">
            <p className="new-space-kicker">Votre plateforme évolue</p>
            <h1 id="new-space-title">
              Votre espace Verdeo
              <br />
              rejoint <span>CreoBoard.</span>
            </h1>
            <p className="new-space-lead">
              Une nouvelle identité et une expérience plus claire pour continuer
              à piloter vos programmes, vos projets, vos financements et leurs
              impacts.
            </p>
            <div className="new-space-actions">
              <a className="new-space-button new-space-button--primary" href={loginUrl}>
                Accéder à mon nouvel espace
                <ArrowIcon />
              </a>
              <a
                className="new-space-button new-space-button--secondary"
                href={contactUrl}
              >
                Contacter l’équipe
              </a>
            </div>
          </section>

          <section
            className="new-space-dashboard"
            aria-label="Aperçu du nouvel espace CreoBoard"
          >
            <img
              src="/new-space/creoboard-dashboard.png"
              alt="Aperçu du tableau de bord CreoBoard avec ses indicateurs et les informations de migration"
            />
          </section>
        </div>

        <section
          className="new-space-tools"
          aria-label="Outils disponibles dans CreoBoard"
        >
          <div className="new-space-tools__title">
            Vous retrouvez vos outils dans CreoBoard.
          </div>
          {tools.map((tool) => (
            <div className="new-space-tools__item" key={tool.label}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                aria-hidden="true"
              >
                {tool.icon}
              </svg>
              {tool.label}
            </div>
          ))}
        </section>
      </main>
    </div>
  );
}
